import { render, staticRenderFns } from "./StudentIndividualProfiles.vue?vue&type=template&id=1e8d96aa&"
import script from "./StudentIndividualProfiles.vue?vue&type=script&lang=js&"
export * from "./StudentIndividualProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports